// extracted by mini-css-extract-plugin
export default {"contractOthersTable":"ContractOthers_contractOthersTable__SAFAU"};